<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SSyGXE/tc-custom/9781504045520.jpg?1737334497836" alt="This image is the cover for the book Madoc and Janet Rhys Mysteries Volume One, The Madoc and Janet Rhys Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Madoc and Janet Rhys Mysteries Volume One, The Madoc and Janet Rhys Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The first three cozy mysteries in a series featuring a Royal Canadian Mountie and his resourceful wife from an international-bestselling author.</b><br/><br/> The beloved sleuthing couple solves a trio of murder cases in the austere beauty of Canada’s New Brunswick. Originally published under the pseudonym Alisa Craig, these three tales are a witty look at murder in a small town—“the epitome of the ‘cozy’ mystery” (<i>Mostly Murder</i>).<br/>  <br/><i>A Pint of Murder</i>: When Janet Wadman realizes her friend Agatha was murdered with a jar of tainted green beans, her discovery leads to another untimely death. Height-challenged Mountie Madoc Rhys proves more capable than he looks, and Janet is duly impressed.<br/>  <br/><i>Murder Goes Mumming</i>: Madoc decides to ask Janet for her hand in marriage. But when the newly engaged couple finds their Christmas plans spoiled by murder, the investigating duo once again finds they have a gift for serving justice.<br/>  <br/><i>A Dismal Thing to Do</i>: Janet witnesses a terrible accident on the back roads of Canada. But after dashing into a nearby barn to get help, someone thanks her by stealing her car and then trying to kill her. Or were they? Madoc arrives and together they work to stop a deadly crime wave in its tracks.<br/><br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte MacLeod
      </h2>
      
      <p class="authorDescription body article">Charlotte MacLeod (1922&ndash;2005) was an international&#160;bestselling author of cozy mysteries. Born in Canada, she moved to Boston as a child&#160;and lived in New England most of her life. After graduating from college, she made a career in advertising, writing copy for the Stop &amp; Shop Supermarket Company before moving on to Boston firm N. H. Miller &amp; Co., where she rose to the rank of vice president. In her spare time, MacLeod wrote short stories, and in 1964 published her first novel, a children&rsquo;s book called <I>Mystery of the White Knight.</I><I>&#160;</I>In <I>Rest You Merry</I> (1978), MacLeod introduced Professor Peter Shandy, a horticulturist and amateur sleuth whose adventures she would chronicle for two decades. <I>The Family Vault </I>(1979) marked the first appearance of her other best-known characters: the husband and wife sleuthing team Sarah Kelling and Max Bittersohn, whom she followed until her last novel, <I>The Balloon Man</I>, in 1998.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d1a45830